<div class="tunnel-page-container">
  <div class="card-marketing-container">
    <ng-casto-card-marketing [imageSrc]="placeholderImageSrc">
    </ng-casto-card-marketing>
  </div>
  <div class="body-container">
    <ng-container #validationContainer></ng-container>
  </div>
  <div class="action-bar-container">
    <ng-casto-action-bar></ng-casto-action-bar>
  </div>
</div>
